import { Button, Input } from 'antd';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { alertify, handleApiExceptions } from '../../../app_methods';
import { EaseModal } from '../../../libs/EaseModal';
import { Merchant } from '../../../models';
import { updateCurrentUserAction } from '../../../redux/actions';
import { Text3, Text4 } from '../../../styles';
import { TransactionHistoryDrawer } from '../../PgTransactionHistory/List/TransactionHistoryInfo';

const CreditCardModal = (props) => {
    const [amount, setAmount] = useState("0.0");
    const [showTransactionHistoryDrawer, setShowTransactionHistoryDrawer] = useState(false);
    const [initPaymentLoader, setInitPaymentLoader] = useState(false);

    const initiate_payment_gateway = async () => {
        if (amount < 1 || amount == "") {
            alertify("Error", "Please enter valid amount(Amount should be greater than Rs.1)", "error");
            return;
        }
        setInitPaymentLoader(true);
        const merchant = new Merchant()
        let response = await merchant.initiate_pg_payment({ "id": props.current_user.id, "amount": amount });
        if (!response.success) {
            if (response.message == "Payment cannot be verified. Hash mismatch." || "Invalid merchant key") {
                response.message = "Something went wrong. Please contact Easebuzz team."
            }
            setInitPaymentLoader(false);
            handleApiExceptions(response);
            return;
        }
        let easebuzzCheckout = new window.EasebuzzCheckout(props.current_user.pgkey, ['local', 'dev'].includes(props.current_user.env) ? 'dev' : 'prod')
        var options = {
            access_key: response.data.access_key,
            onResponse: (response) => {
                merchant.update_pg_payment(response)
                if (response.status == "success") {
                    alertify("Transaction Successful", "Amount will be credited to the virtual account as per settlement cycle.", "success");
                } else if (response.status == "failure" || response.status == "userCancelled" || response.status == "dropped") {
                    alertify("Transaction Failed", "Transaction has failed. Please try again.", "error");
                } else {
                    alertify("Transaction Initiated", "Transaction has been initiated. Please wait for the final status.", "info");
                }
            }
            // theme: "#123456"
        }
        setInitPaymentLoader(false);
        easebuzzCheckout.initiatePayment(options);
    };

    const amountInWords = (value) => {
        try {
            const numWords = require('num-words');
            const InWords = numWords(value);
            return InWords + " Rupees";
        }
        catch (err) {
            return null
        }
    };

    const toggleTransactionHistoryDrawer = () => {
        setShowTransactionHistoryDrawer(!showTransactionHistoryDrawer);
        setAmount("0.0")
    };

    const viewTransactionHistoryDrawer = () => {
        toggleTransactionHistoryDrawer()
    };

    const virtual_account = props.current_user.virtual_account || {};

    const onCancel = () => {
        setAmount("0.0");
        props.onCancel()
    }

    return (
        <div id="CreditCardModal">
            <EaseModal
                width={450}
                title={false}
                visible={props.visible}
                onCancel={onCancel}
                centered
                hideFooter
                destroyOnClose
            >
                <>
                    <div className="row">
                        <div className="col-12">
                            <div className="font-weight-bold mb-3" style={{ fontSize: "18px" }}>{props.virtualAccount.account_type_label}</div>
                            <Text4 strong className='mt-2'>Amount to Fund:</Text4>
                            <Input className='mt-1 mb-3' type='number' addonBefore='₹' addonAfter="/-" defaultValue="0.0" value={amount} onChange={e => setAmount(e.target.value)} />
                            <Text4 strong className='mt-1'>Amount in Words:</Text4>
                            <p id='amount-to-words'>{amount > 0 ? <Text4 className='mt-2' style={{ textTransform: "capitalize" }}>{amountInWords(amount)}</Text4> : "---"}</p>
                            <div className='d-flex align-items-center justify-content-between'>
                                <Button onClick={() => { props.onCancel(); viewTransactionHistoryDrawer() }} type="ghost">View Transaction History</Button>
                                <Button loading={initPaymentLoader} type='primary' onClick={initiate_payment_gateway}>Proceed to Pay</Button>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-12">
                            <Text3 strong>PLEASE NOTE:</Text3>
                            <ul className="mt-1" style={{ paddingLeft: "5%" }}>
                                <li><Text4>Click on the <strong>Proceed to Pay</strong> button to open the checkout window. </Text4></li>
                                <li><Text4>You can pay via any of the available payment mode on the checkout window. </Text4></li>
                                <li><Text4>Virtual account will be funded as per agreed settlement cycle. </Text4></li>
                            </ul>
                        </div>
                    </div></>
            </EaseModal>
            <TransactionHistoryDrawer
                visible={showTransactionHistoryDrawer}
                toggleTransactionHistoryDrawer={toggleTransactionHistoryDrawer}
            />
        </div>)
}

const mapStateToProps = (state) => ({
    current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
    updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreditCardModal);